import './App.css';
import { ReactFlowProvider } from '@xyflow/react';
import RoadmapEditor from './components/RoadmapEditor';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import RoadmpScreen from './components/client-canvas/RoadmapScreen';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { UserProvider } from './context/UserContext';
import RoadmapsLandingScreen from './components/client-canvas/RoadmapsLandingScreen';
import CreateRoadmapScreen from './components/CreateRoadmapScreen';
import RoadmapAccessSharing from './components/RoadmapAccessSharing';
import { RoadmapProvider } from './context/RoadmapContext';
import { SidebarProvider } from './context/SidebarContext';
import PaymentScreen from './components/client-canvas/PaymentScreen';
import { ClientRoadmapContextProvider } from './context/ClientRoadmapContext';
import Notifier from './components/roadmap-utility/Notifier';
import { ConfirmationProvider } from './context/ConfirmationContext';

function App() {
  return (
    <>
      <UserProvider>
        <ConfirmationProvider>
          <RouterProvider router={router} future={{v7_startTransition: true, v7_relativeSplatPath: true}} />
        </ConfirmationProvider>
      </UserProvider>
      <Notifier />
    </>
  );
}

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: <ProtectedRoute allowedRoles={['learner', 'admin']} />,
    children: [
      {
        path: '/roadmap/:roadmap_id',
        element: (
          <ClientRoadmapContextProvider>
            <RoadmpScreen />
          </ClientRoadmapContextProvider>
        ),
      },
      {
        path: '/',
        element: <RoadmapsLandingScreen />,
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRoles={['admin']} />,
    children: [
      {
        path: '/draw-roadmap/create',
        element: <CreateRoadmapScreen />,
      },
      {
        path: '/draw-roadmap/:roadmap_id',
        element: (
          <ReactFlowProvider>
            <RoadmapProvider>
              <SidebarProvider>
                <RoadmapEditor />
              </SidebarProvider>
            </RoadmapProvider>
          </ReactFlowProvider>
        ),
      },
      {
        path: '/preview/:roadmap_id',
        element: (
          <ClientRoadmapContextProvider>
            <RoadmpScreen mode={'preview'} />
          </ClientRoadmapContextProvider>
        ),
      },
      {
        path: '/r/access-sharing',
        element: <RoadmapAccessSharing />,
      },
    ],
  },
  {
    path: '/pay',
    element: <PaymentScreen />,
  },
  {
    path: '*',
    element: <h2>404 Error</h2>,
  },
]);

export default App;
